import React from 'react';
import { PropTypes } from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import FirebaseStore from 'stores/FirebaseStore';
import ProfileStore from 'stores/ProfileStore';
import TippingStore from 'stores/TippingStore';
import { NEW_SHOWS_STATE } from 'enum/videoPlayer';

import DMCABadgeImg from '../../../../images/DMCABadge.png';

import styles from './DMCABadge.css';


const DMCABadge = ({ isDesktop, isTrueFullScreen }) => {
  const { deviceInLandscape } = ProfileStore;
  const { newShowsState } = FirebaseStore;
  const isGoalVisible = TippingStore.isPerformerGoalVisible || newShowsState === NEW_SHOWS_STATE.GS_SELLING_TICKETS;

  const DMCABadgeWrapper = classNames({
    [styles.DMCABadgeWrapperDesktop]: isDesktop,
    [styles.DMCABadgeWrapperMobile]: !isDesktop && !deviceInLandscape,
    [styles.DMCABadgeWrapperMobileHide]: (!isDesktop && isGoalVisible) || (!isDesktop && deviceInLandscape),
    [styles.DMCABadgeWrapperMobileFullScreen]: isTrueFullScreen,
  });

  return (
    <div className={DMCABadgeWrapper}>
      <img alt="DMCABadge" className={styles.DMCABadge} src={DMCABadgeImg} />
    </div>
  );
};

DMCABadge.propTypes = {
  isDesktop: PropTypes.bool.isRequired,
  isTrueFullScreen: PropTypes.bool,
};

DMCABadge.defaultProps = { isTrueFullScreen: false };

export default observer(DMCABadge);
